export var BusinessModalNames;
(function (BusinessModalNames) {
    BusinessModalNames["WHOS_BOOKING"] = "whos_booking";
    BusinessModalNames["ONBOARDING_CHECKLIST"] = "onboarding_checklist";
})(BusinessModalNames || (BusinessModalNames = {}));
export var BookingOptionsKeys;
(function (BookingOptionsKeys) {
    BookingOptionsKeys["MYSELF_AND_OTHERS"] = "book_for_myself_and_others";
    BookingOptionsKeys["EMPLOYEES_THEMSELVES"] = "employees_book_for_themselves";
    BookingOptionsKeys["SOMEONE_ELSE"] = "someone_else_books_for_everyone";
    BookingOptionsKeys["MYSELF"] = "book_for_myself";
})(BookingOptionsKeys || (BookingOptionsKeys = {}));
//# sourceMappingURL=businesses.js.map